import { Box, Button, Card, Flex, Heading, Text } from "@radix-ui/themes";
import i18next from "i18next";
import { FC } from "react";
import { usePrecisionGame } from "../hooks/usePrecisionGame";
import { PrecisionGameUIProps } from "../models/precisionGame.types";
import PrecisionGameUISuccess from "./precision.game.ui.success";

const PrecisionGameUIActivity: FC<PrecisionGameUIProps> = ({
  collection,
}): JSX.Element => {
  const { attemptCount, success, handleClick, currentTime, firstClickTime } =
    usePrecisionGame(collection);

  return (
    <Box>
      <Card size="5" className="rt-variant-elgiganten">
        <Box>
          {!success && (
            <>
              {firstClickTime ? (
                <Heading size="9" align="center" mx="0" my="9">
                  {currentTime}
                </Heading>
              ) : (
                <Heading size="9" align="center" mx="0" my="9">
                  {currentTime}
                </Heading>
              )}
            </>
          )}

          {success && (
            <>
              <Heading size="9" align="center" m="9">
                1337
              </Heading>
            </>
          )}
        </Box>
      </Card>

      <Flex style={{ transform: "translateY(-50%)", padding: "0 1rem" }}>
        {!success && (
          <Button
            size="4"
            radius="full"
            disabled={success}
            onClick={handleClick}
            style={{ width: "100%" }}
          >
            {!firstClickTime ? (
              <>
                {success
                  ? i18next.t("precisionGame.youWon")
                  : i18next.t("precisionGame.start")}
              </>
            ) : (
              <>{i18next.t("precisionGame.stop")}</>
            )}
          </Button>
        )}
      </Flex>
      <PrecisionGameUISuccess success={success} />
      <Flex justify="center">
        <Text align="center" size="2" color="gray">
          {i18next.t("precisionGame.totalAttempts")}: {attemptCount}
        </Text>
      </Flex>
    </Box>
  );
};

export default PrecisionGameUIActivity;
